import useBuyTicketFormDetailsService from "./service";
import { ApplicableViewEnum } from "./constants";
import TicketUpgradeForm from "./ticketUpgradeForm";
import { useCopies } from "shared/hooks/useCopies";
import { PurchaseOrderDetails } from "../../../../../shared/components/purchaseOrder";
import PaymentComponentWrapper from "../../../../../shared/components/paymentWrapper";
import { getStripeReturnUrlForMyExp, isPaymentReceiptPendingForPO } from "../../../utils";
import { useRegDetail } from "../../../../../shared/context/regDetail";
import CouponCodeFlow from "../../../components/couponCodeFlow";
import MyExpApi from "../../../enum/MyExpApi";
import ApiPurchaseOrder from "../../../../../shared/model/ApiPurchaseOrder";
import { ApiAmount } from "../../../../../shared/types/ApiAmount";
import ConfirmationView from "./confirmationView";
import Button from "../../../../../shared/components/button";
import FormApplicablePriceDetails from "./formApplicablePriceDetails";
import Icon from "assets/icons";

export default function BuyTicketFormDetails() {
  const copies = useCopies();
  const service = useBuyTicketFormDetailsService();
  const { showCardIcons } = useRegDetail();

  if (!service.formUpgradeTicketDetails) {
    return null;
  }

  return (
    <div className="ticketUpgrade_buyTicketForm">
      <div className="ticketUpgrade_buyTicketForm_header">
        {service.state.activeView !== ApplicableViewEnum.CONFIRMATION &&
          !service.isInvoicePaymentOrOfflineApprovalPending && (
            <div className="ticketUpgrade_buyTicketForm_header--back">
              <Button
                isOutline
                icon={<Icon.BackTo />}
                label={copies.get("back")}
                className="eventPrivileges_purchaseDetails--backBtn"
                onClick={service.backClickHandler}
              />
            </div>
          )}
      </div>
      <div className="ticketUpgrade_buyTicketForm_body">
        {service.state.activeView === ApplicableViewEnum.COUPON_CODE && (
          <div className="tcktUpBuyTicketForm_couponCode">
            <FormApplicablePriceDetails
              regParticipantFormDetails={service.formUpgradeTicketDetails.registrationParticipantForm}
              ticketUpgradeDetails={service.formUpgradeTicketDetails.registrationFormForTicketUpgrade}
              applicablePrice={service.state.couponApplyApplicableRate?.priceDifference}
              appliedCouponCode={service.state.couponApplyApplicableRate?.couponCode}
            />
            <CouponCodeFlow
              onApplySuccessHandler={service.couponCodeApplySuccessHandler}
              noCouponCodeHandler={service.withoutCouponCodeHandler}
              invalidCouponCodeHandler={service.invalidCouponCodeHandler}
              apiUrl={MyExpApi.TICKET_CHANGE_GET_FORM_DETAIL}
              couponCode={service.state.couponApplyApplicableRate?.couponCode}
              apiReqData={{
                upgradeRegistrationFormId:
                  service.formUpgradeTicketDetails.registrationParticipantForm.registrationForm.id,
                registrationParticipantId: service.participantDetails?.registrationParticipantId
              }}
              purchaseOrderCreated={Boolean(service.state.purchaseOrder)}
            />
          </div>
        )}
        {service.state.activeView === ApplicableViewEnum.FORM_DETAILS && (
          <div className="tcktUpBuyTicketForm_formDetails">
            <FormApplicablePriceDetails
              regParticipantFormDetails={service.formUpgradeTicketDetails.registrationParticipantForm}
              ticketUpgradeDetails={service.formUpgradeTicketDetails.registrationFormForTicketUpgrade}
              applicablePrice={service.state.couponApplyApplicableRate?.priceDifference}
              appliedCouponCode={service.state.couponApplyApplicableRate?.couponCode}
            />
            <TicketUpgradeForm
              regParticipantFormDetails={service.formUpgradeTicketDetails.registrationParticipantForm}
              ticketUpgradeDetails={service.formUpgradeTicketDetails.registrationFormForTicketUpgrade}
              appliedCouponCode={service.state.couponApplyApplicableRate?.couponCode}
              applicablePrice={service.state.couponApplyApplicableRate?.priceDifference}
              onSuccessHandler={service.initiateFormSuccessHandler}
            />
          </div>
        )}
        {service.state.activeView === ApplicableViewEnum.PAYMENT_DETAILS && (
          <div className="purchaseTicketPayment">
            <PurchaseOrderDetails
              purchaseOrder={service.state.purchaseOrder as ApiPurchaseOrder}
              originatingFormName={
                service.formUpgradeTicketDetails.registrationParticipantForm?.registrationForm?.title
              }
            />
            <PaymentComponentWrapper
              purchaseOrderId={service.state.purchaseOrder?.purchaseOrderId as string}
              amount={service.state.purchaseOrder?.amount as ApiAmount}
              registrationParticipantId={service.participantDetails?.registrationParticipantId as string}
              successHandler={service.paymentSuccessHandler}
              errorHandler={service.paymentErrorHandler}
              showCardIcons={showCardIcons}
              onAmountMismatch={service.paymentMismatchHandler}
              stripeReturnUrl={getStripeReturnUrlForMyExp({
                registrationParticipantId: service.participantDetails?.registrationParticipantId as string,
                purchaseOrderId: service.state.purchaseOrder?.purchaseOrderId as string
              })}
              offlinePaymentConfig={{
                offlinePaymentRequested: isPaymentReceiptPendingForPO(service.state.purchaseOrder),
                paymentReferenceId: service.state.purchaseOrder?.transaction?.providerPaymentId
              }}
              offlineTransactionUpdateSuccessHandler={service.offlineTransactionUpdateSuccessHandler}
              offlineTransactionCancelSuccessHandler={service.offlineTransactionCancelSuccessHandler}
            />
          </div>
        )}
        {service.state.activeView === ApplicableViewEnum.CONFIRMATION && (
          <ConfirmationView
            ticketUpgradeFormDetails={service.formUpgradeTicketDetails.registrationParticipantForm}
            purchaseOrder={service.state.purchaseOrder as ApiPurchaseOrder}
          />
        )}
      </div>
    </div>
  );
}
